// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f"}[chunkId] || chunkId) + "." + {"203":"060c2b397df450bf","218":"817b6028e80a85d6","316":"83f2bbcd93d01219","457":"b0e49603abc86336","501":"d13bf505216111a2","839":"fffcf6530291d2f5"}[chunkId] + ".js";
};